import React from 'react';
import styled from 'styled-components';

interface FormTitleInterface {
  title: string;
}

const FormTitle = ({
  title
}: FormTitleInterface) => {
  return (
    <Title>
      <p>{title}</p>
    </Title>
  )
}

export default FormTitle;

const Title = styled.div`
  p {
    margin: 0 0;
    font-family: 'Poppins-Medium';
    font-size: 1rem;
  }
`;